import { Alert, Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'

/**
 * Tenant admin: prompt to add a client before campaigns / metrics. Optional test id for E2E.
 */
export function AdminNoClientsBanner({ message, 'data-testid': dataTestId }) {
  const navigate = useNavigate()
  return (
    <Alert
      severity="info"
      sx={{ mb: 2 }}
      data-testid={dataTestId}
      action={(
        <Button
          color="inherit"
          size="small"
          onClick={() => navigate('/admin/clients', { state: { openCreateClient: true } })}
        >
          Add client
        </Button>
      )}
    >
      {message}
    </Alert>
  )
}
